import { API } from "api/axios.config";
import { createApplicationService } from "./base/applicationServiceBase";
import { useCallback, useEffect, useState } from "react";

const ACTIVITY_TAG_BASE = "/ActivityTags";

const getActivityTagAPI = () => API.get(`${ACTIVITY_TAG_BASE}`);

const addActivityTagAPI = (data) =>
  API.post(`${ACTIVITY_TAG_BASE}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const updateActivityTagAPI = (id, data) =>
  API.patch(`${ACTIVITY_TAG_BASE}/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const getMatterActivityTagsAPI = (matterId) =>
  API.get(`${ACTIVITY_TAG_BASE}?active=true&MatterId=${matterId}`);

const baseService = createApplicationService({
  name: "activityTags",
  apiFetchFn: getActivityTagAPI,
  apiAddFn: addActivityTagAPI,
  apiUpdateFn: updateActivityTagAPI,
});

const activityTagReducer = baseService.reducer;
const getActivityTag = baseService.getData;
const addActivityTag = baseService.addData;
const updateActivityTag = baseService.updateData;
const useActivityTag = baseService.useData;

const useMatterActivityTags = (matterId) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const refresh = useCallback(() => setRefreshKey((k) => k + 1), []);

  useEffect(() => {
    if (!matterId) {
      setData([]);
      setFetched(true);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setFetched(false);
    getMatterActivityTagsAPI(matterId)
      .then((res) => {
        if (!cancelled) setData(res.data?.data || []);
      })
      .catch(() => {
        if (!cancelled) setData([]);
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
          setFetched(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [matterId, refreshKey]);

  return { data, loading, fetched, refresh };
};

export {
  activityTagReducer,
  getActivityTag,
  getActivityTagAPI,
  addActivityTagAPI,
  addActivityTag,
  updateActivityTag,
  useActivityTag,
  useMatterActivityTags,
};
